// Not to put any values before CBLSES in future, cause it will break logic
export enum NotificationMethod {
  CBLSMTP = 0,
  CBLSES = 1,
  SMTP = 2,
  SES = 3
}

export enum NotificationStatus {
  NotConfigured = 0,
  VerifyEmail = 1,
  ConfigureProductionAccess = 2,
  SendTestEmail = 3,
  Ready = 4
}

export enum NotificationPlanRule {
  None = 0,
  Provider = 1 << 0,
  Administrators = 1 << 1,
  Users = 1 << 2,
  SpecifiedEmails = 1 << 3,
  Full = Provider | Administrators | Users | SpecifiedEmails
}

export enum NotifyToPlatform {
  ServersOnly = 0,
  All = 1
}

export enum NotifyToPlatformString {
  ServersOnly = 'Servers',
  All = 'All'
}

export type OldNotificationTypes = 'Failure' | 'Success' | 'Warning';
export enum ThresholdUnit {
  Day,
  Hour
}

export class NotificationRuleSettings {
  rule: NotificationPlanRule = NotificationPlanRule.None;
  emails: string[] = [];
  threshold: number = null;
  thresholdUnit?: ThresholdUnit = ThresholdUnit.Day;
}

export class NotificationPlanTypeSettings {
  failure: NotificationRuleSettings = new NotificationRuleSettings();
  warning: NotificationRuleSettings = new NotificationRuleSettings();
  success: NotificationRuleSettings = new NotificationRuleSettings();
  noSuccess?: NotificationRuleSettings = new NotificationRuleSettings();
}

export class NotificationO365Settings {
  officeOn: boolean;

  constructor(state: boolean) {
    this.officeOn = state;
  }
}

export class NotificationPerPlanSettings extends NotificationPlanTypeSettings {
  enabled = false;
  planId: string;
  userId: string;
}

export class DeepInstNotificationSettings {
  recipient: any = {
    type: NotificationPlanRule.None,
    emails: []
  };
  malwareDetected = { enabled: false };
  malwarePrevented = { enabled: false };
}

export class NotificationSettings {
  allowNotifyEndUsers = false;
  backupNotificationSettings: NotificationPlanTypeSettings = new NotificationPlanTypeSettings();
  restoreNotificationSettings: NotificationPlanTypeSettings = new NotificationPlanTypeSettings();
  deepInstAlertNotificationSettings: DeepInstNotificationSettings = new DeepInstNotificationSettings();
  officeBackupNotificationSettings: { enabled: boolean } = { enabled: false };
}

export class NotificationCustom extends NotificationSettings {
  companyId: string;
  customBackupNotification = false;
  customRestoreNotification = false;
  customRmmNotification = false;
  customDeepInstNotification = false;
}

export class CBLSettings {
  status?: NotificationStatus;
}

export class SMTPSettings extends CBLSettings {
  server: string;
  port: string;
  ssl: boolean;
  user: string;
  password: string;
  enabled?: boolean;
}

export class SESSettings extends CBLSettings {
  account: string;
  sesAccountError: string;
}

export class NotificationGeneralProvider {
  status: NotificationStatus;
  type = NotificationMethod.CBLSES;
  smtpSettings: SMTPSettings;
  sesSettings: SESSettings;
  cblseSSettings: CBLSettings;
  emailFrom: string;
  to: string;
}

export interface EditEmailsNotification {
  type: OldNotificationTypes;
  emails: { email: string }[];
}

export enum EmailServiceStatus {
  NotConfigured = 0,
  InProgress = 1, // did not finish configuring
  Ready = 2
}

export interface GetBouncedListRequestParams {
  offset?: number;
  limit?: number;
  from?: string;
  to?: string;
  search?: string;
  type?: string;
}

export interface GetBouncedListResponse {
  data: Array<BouncedEmail>;
  total: number;
}

export interface BouncedEmail {
  email: string;
  type: BounceType;
  date: string;
}

export enum BounceType {
  PermanentBounce = 'PermanentBounce',
  TransientBounce = 'TransientBounce',
  Complaint = 'Complaint'
}

export enum DomainIdentityStatus {
  // DnsRecords is empty
  None,
  // DnsRecords is empty
  NotConfigured,
  Pending,
  Failed,
  Success,
  // Identity is configured, but DKIM signing is disabled for emails
  Disabled,
  NotStarted
}

export type CblsesDomainVerificationResponse = {
  status: DomainIdentityStatus;
  dnsRecords?: {
    type: string;
    name: string;
    value: string;
  }[];
};
